import SectionHeading from '@/pages/home/components/SectionHeading';
import { characterFiles } from '@/mocks/homeData';

function statusStyle(status: string) {
  if (status === '持续争议' || status === '热度上升') {
    return 'bg-primary-100 text-primary-700 border-primary-200';
  }
  if (status === '已回应' || status === '新增证言') {
    return 'bg-accent-100 text-accent-800 border-accent-300';
  }
  return 'bg-secondary-100 text-secondary-900 border-secondary-200';
}

export default function CharacterFiles() {
  return (
    <section id="files" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="分区 03 · 人品盘点"
          title="争议档案：把零散说法整理成一条时间线"
          desc="每份档案只记录被多次提及的公开讨论方向，配以当前状态标签。档案会随讨论持续更新，也会随着纠错而调整。"
          actionLabel="按更新时间浏览"
          actionHref="#unfollow"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {characterFiles.map((file) => (
            <article
              key={file.name}
              className="flex flex-col rounded-lg border border-foreground-200/80 bg-background-50 p-5 transition-colors duration-200 hover:border-foreground-300"
            >
              <div className="flex items-start gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-foreground-950 font-heading text-lg font-bold text-background-50">
                  {file.initial}
                </span>
                <div className="min-w-0">
                  <h4 className="truncate font-heading text-base font-bold text-foreground-950">
                    {file.name}
                  </h4>
                  <p className="mt-0.5 font-label text-[12px] text-foreground-500">
                    {file.identity}
                  </p>
                </div>
              </div>

              <span
                className={`mt-4 inline-flex w-fit items-center rounded-full border px-2.5 py-1 font-label text-[11px] ${statusStyle(
                  file.status,
                )}`}
              >
                {file.status}
              </span>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {file.issue}
              </p>

              <div className="mt-4 rounded-md bg-background-100 px-3 py-2.5">
                <span className="font-label text-[11px] text-foreground-500">参考建议</span>
                <p className="mt-1 font-label text-[13px] text-foreground-800">{file.stance}</p>
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-foreground-200/70 pt-3">
                <span className="font-label text-[12px] text-foreground-500">
                  更新于 {file.updated}
                </span>
                <span className="flex items-center gap-1.5 font-label text-[12px] text-primary-600">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-chat-3-line text-sm" />
                  </span>
                  {file.count} 条讨论
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}